import { createContext, useContext, useState } from "react";

const ZoomContext = createContext(null);

export function ZoomProvider({ children }) {
  const [zoomRange, setZoomRange] = useState(null);

  return (
    <ZoomContext.Provider value={{ zoomRange, setZoomRange }}>
      {children}
    </ZoomContext.Provider>
  );
}

export function useZoom() {
  return useContext(ZoomContext);
}
